module.exports = __webpack_public_path__ + "static/media/menu_profissionais.21ea53e2.png";